import { BROADCAST_UPDATE_PRESENTER_SETTINGS } from 'actions/Types';
import updateSource from 'actions/Broadcast/sources/updateSource';
import setAttendeeName from '@shoflo/studio-redux/actions/attendee/setAttendeeName';
import {
  ATTENDEE_DETAILS_CHANGED,
  PRESENTER_AUDIO_BITRATE_CHANGE
} from 'store/eventConstants';
import setAttendeeContentShareAudioProfile from 'actions/Broadcast/attendees/setAttendeeContentShareAudioProfile';

export default (source, payload) => {
  return (dispatch, getState, socket) => {
    const { broadcast, attendeeContentShareAudioProfile } = getState();

    const broadcastId = broadcast?._id;

    const action = {
      type: BROADCAST_UPDATE_PRESENTER_SETTINGS,
      request: async () => {
        if (payload.bitRate || payload.contentShareAudioProfile) {
          const data = {
            attendeeId: source.value,
            broadcastId,
            bitRate: payload.bitRate,
            contentShareAudioProfile: payload.contentShareAudioProfile
          };
          socket.emit(PRESENTER_AUDIO_BITRATE_CHANGE, data);
        }
        const currentAttendeeContentAudioProfile =
          attendeeContentShareAudioProfile[source.value];
        if (
          currentAttendeeContentAudioProfile !==
          payload.contentShareAudioProfile
        ) {
          dispatch(
            setAttendeeContentShareAudioProfile(
              source.value,
              payload.contentShareAudioProfile
            )
          );
        }
      }
    };

    const { source_title: title, description } = payload;
    const {
      _id: sourceId,
      value: sourceValue,
      description: sourceDescription,
      title: sourceTitle
    } = source;
    const didTitleChange = title && title !== sourceTitle;
    // Alow source description to be set to empty string
    const didDescriptionChange = description !== sourceDescription;

    if (didTitleChange || didDescriptionChange) {
      let changes = {
        title: title,
        description: description
      };
      dispatch(updateSource(sourceId, changes));
      dispatch(
        setAttendeeName(sourceValue, title, source?.photo, source?.role)
      );
      changes = { ...changes, presenterPhoto: source?.photo };
      socket.emit(ATTENDEE_DETAILS_CHANGED, {
        ...changes,
        attendeeId: source.value,
        broadcastId
      });
      return source;
    }
    dispatch(action);
  };
};
